
import Spacious from './spacious';
import Compact from './compact';
export { Spacious, Compact };
export default { Spacious, Compact };